import Services from "services";

class COAGroupApi {
  getList(params) {
    return Services.get("/groupcoa/", { params });
  }
}

export default new COAGroupApi();
